// src/store/waterStore.js
import { create } from 'zustand';
import * as THREE from 'three';

// Function to load state from localStorage
const loadState = () => {
  try {
    const savedState = localStorage.getItem('waterParams');
    if (savedState === null) {
      return undefined; // No saved state
    }
    return JSON.parse(savedState);
  } catch (err) {
    console.error("Could not load state from localStorage", err);
    return undefined; // Use default state on error
  }
};

// Updated initial state for Night Sky water effect
/* // Comment out old defaults
const initialState = {
  seaHeight: 0.25,     // Lower waves
  seaChoppy: 1.5,      // Less sharp peaks
  seaSpeed: 0.35,      // Slower movement
  seaFreq: 0.2,        // Smaller wave patterns
  seaBaseColor: '#01030a',   // Very dark blue base
  seaWaterColor: '#0b1833', // Subtle dark blue highlights
  skyIntensity: 0.05,    // Very dim sky reflection
};
*/

// Set new defaults based on user's localStorage values
const initialState = {
    seaHeight: 0.14,
    seaChoppy: 3.1,
    seaSpeed: 0.32999999999999996, // Kept exact value
    seaFreq: 0.25,
    seaBaseColor: "#0c8bc1",
    seaWaterColor: "#505469",
    skyIntensity: 1.3
};

const useWaterStore = create((set) => ({
  // Load initial state from localStorage or use defaults
  ...(loadState() || initialState),

  // Add methods to update parameters
  setSeaHeight: (val) => set({ seaHeight: parseFloat(val) || 0 }),
  setSeaChoppy: (val) => set({ seaChoppy: parseFloat(val) || 0 }),
  setSeaSpeed: (val) => set({ seaSpeed: parseFloat(val) || 0 }),
  setSeaFreq: (val) => set({ seaFreq: parseFloat(val) || 0 }),
  setSeaBaseColor: (val) => set({ seaBaseColor: val }),
  setSeaWaterColor: (val) => set({ seaWaterColor: val }),
  setSkyIntensity: (val) => set({ skyIntensity: parseFloat(val) || 0 }),

  // Helper to get THREE.Color objects
  getSeaBaseColorTHREE: () => new THREE.Color(useWaterStore.getState().seaBaseColor),
  getSeaWaterColorTHREE: () => new THREE.Color(useWaterStore.getState().seaWaterColor),
}));

// Function to save state to localStorage
export const saveState = () => {
  try {
    const stateToSave = useWaterStore.getState();
    // Only save the parameter values, not the functions
    const paramsOnly = {
      seaHeight: stateToSave.seaHeight,
      seaChoppy: stateToSave.seaChoppy,
      seaSpeed: stateToSave.seaSpeed,
      seaFreq: stateToSave.seaFreq,
      seaBaseColor: stateToSave.seaBaseColor,
      seaWaterColor: stateToSave.seaWaterColor,
      skyIntensity: stateToSave.skyIntensity,
    };
    const serializedState = JSON.stringify(paramsOnly);
    localStorage.setItem('waterParams', serializedState);
    console.log("Water params saved to localStorage");
  } catch (err) {
    console.error("Could not save state to localStorage", err);
  }
};

export default useWaterStore; 